import { Injectable } from '@angular/core';

function getDocument (): any {
    return document;
}
@Injectable({
  providedIn: 'root'
})
export class DocumentRefService {

  constructor() { }
  get nativeDocument (): any {
        return getDocument();
    }
}
